import type { CSSObject } from '@emotion/react'
import classNames from 'classnames'
import React, {
  DetailedHTMLProps,
  TextareaHTMLAttributes,
  Fragment,
} from 'react'
import { WithTheme } from '../../../gem'
import { ErrorMessage } from '../../TextInput/errorMessage'
import * as styles from '../styles'

type TextAreaProps = Readonly<
  WithTheme & {
    error?: string
    themeOverrides?: styles.AutoExpandTextAreaThemeOverrides
    styleOverrides?: CSSObject
    errorStyleOverrides?: CSSObject
  }
> &
  DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props: TextAreaProps, ref) => {
    const {
      errorStyleOverrides,
      className,
      styleOverrides,
      theme = 'light',
      themeOverrides,
      error,
      ...textAreaProps
    } = props

    return (
      <Fragment>
        <textarea
          // '.styled' classname needed to prevent supernova styles from
          // overriding gem styles when used in Backbone views
          className={classNames(['lapidary-textarea', 'styled', className])}
          css={[
            styles.textArea({ theme, themeOverrides }),
            { inlineSize: '100%' },
            error ? styles.error(theme) : null,
            styleOverrides,
          ]}
          {...textAreaProps}
          ref={ref}
        />
        <ErrorMessage
          message={error}
          styleOverrides={errorStyleOverrides}
          theme={theme}
        />
      </Fragment>
    )
  }
)
TextArea.displayName = 'Lapidary: TextArea'
